import { render, staticRenderFns } from "./ProviderSubTitle.vue?vue&type=template&id=b7d3d2ee&scoped=true&"
import script from "./ProviderSubTitle.vue?vue&type=script&lang=js&"
export * from "./ProviderSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSubTitle.vue?vue&type=style&index=0&id=b7d3d2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d3d2ee",
  null
  
)

export default component.exports